import React, {useContext, useEffect, useState} from 'react'
import ReserveCard from './ReserveCard'

export default function ReserveList ({user}){

const [reservas, setReservas] = useState(null);

    
      useEffect(() => {
        const data = {
            peticion: 10,
                idEntidad: user.idEntidadG
                 }
                 //console.log(data)
       const consultarReservas = async () =>{
        try {
        const response = await fetch('https://estanciamargarita.com.ar/backendBeta/php/servicios/servicioEntidadG.php', {
            method: 'POST',
            headers: new Headers(), // no incluimos Content-Type para evitar preflight
            body: JSON.stringify(data),
    })
    const result = await response.json();
    setReservas(result)
    //console.log(result)
}
    catch(error){
        console.error(error);
    }
       }
       consultarReservas();
      }, [user]);


    return (
        <div className='flex-1  p-5 m-5 rounded-lg'>
       

        { reservas &&
            reservas?.map((reserva, index) => {
                return (
                <>
                
                <ReserveCard reserva={reserva} id={index} />
              
                </>
                         )})
                        
                        
    }
        
       

        </div>
    )
} 